import { EBillingPeriodType } from "../../Enum/EBillingPeriodType"

export class AdminCreatePlanPeriod {
  eBillingPeriodType: EBillingPeriodType

  price: number

  constructor(data: Partial<AdminCreatePlanPeriod> = {}) {
    this.eBillingPeriodType = data.eBillingPeriodType ?? EBillingPeriodType.Monthly

    this.price = data.price ?? 0
  }
}
